import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSquare = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		width: 14,
		height: 14,
		rx: 2
	})
});
export default SvgSquare;
